export default __webpack_public_path__ + "static/media/ido.02311529.svg";